<template>
  <div id="products-inventum">
    <PageHeader />
    <main>
      <section id="main" class="green white-text hero-section">
        <div class="container flex-container pt-4 lg:pt-12 pb-8">
          <div class="flex-item mr-3 hide-on-med-and-down" style="text-align: center">
            <PictureImg
              src="/images/products/inventum/mockup-inventum"
              alt="Aplikasi Inventum"
              version="1"
              :extensions="['webp', 'png']"
              :lazy="false"
              img-class="hero-image"
            />
          </div>
          <div class="flex-item">
            <div class="hero-text">
              <h4 class="font-bold">Inventum</h4>
              <p class="font-medium text-lg lg:text-xl text-balance">
                Inventum (Alat Inventarisasi Tumbuhan) adalah aplikasi yang dirancang khusus untuk mempermudah dalam
                menginput data tumbuhan di lapang secara offline. Hasilnya dapat langsung didownload dalam bentuk
                spreadsheet (xlsx/csv), sehingga proses pengumpulan data menjadi lebih efektif dan efisien.
              </p>
              <br />
              <a
                class="cta-googleplay"
                href="https://play.google.com/store/apps/details?id=id.rasylva.inventum&utm_source=rasylva-web&utm_campaign=products-inventum-cta"
              >
                <PictureImg
                  src="/images/products/inventum/googleplay-download"
                  alt="Get it on Google Play"
                  version="1"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '160px' }"
                />
              </a>
              <p class="m-0 text-sm">Untuk perangkat Android</p>
              <br />
              <a class="cta-pwa" href="/inventum?utm_source=rasylva-web&utm_campaign=products-inventum-cta">
                <PictureImg
                  src="/images/products/inventum/pwa-launch"
                  alt="Launch as PWA"
                  version="1"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '156px', marginLeft: '1px' }"
                />
              </a>
              <p class="m-0 text-sm">
                Untuk perangkat iOS, Windows, Linux, dll&nbsp;
                <span
                  data-tooltip="PWA adalah singkatan dari Progressive Web App. PWA merupakan sebuah website yang bisa digunakan seperti aplikasi biasa, sehingga dapat digunakan secara offline. PWA hanya membutuhkan internet saat pertama kali dibuka."
                  ><i class="material-icons" style="font-size: 16px">help_outline</i></span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="hide-on-large-only">
          <div style="overflow: hidden; width: 100vw; position: absolute">
            <PictureImg
              src="/images/products/inventum/mockup-inventum"
              alt="Aplikasi Inventum"
              version="1"
              :extensions="['webp', 'png']"
              :lazy="false"
              img-class="hero-image"
            />
          </div>
        </div>
      </section>
      <div class="hero-space"></div>

      <section id="features">
        <div class="container">
          <h2
            class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 lg:mt-24 lg:mb-12"
          >
            Fitur Unggulan Inventum
          </h2>
        </div>
        <div class="container">
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div class="card flex flex-col lg:flex-row items-center rounded-lg m-0 px-6 py-4 gap-4">
              <div class="w-1/2 lg:w-1/4 shrink-0">
                <PictureImg
                  src="/images/products/inventum/feature-tree"
                  alt="Feature 1"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '100%', height: '100px', objectFit: 'contain' }"
                />
              </div>
              <div>
                <h3 class="text-xl font-bold mt-0 mb-2">Pencatatan Beragam Data Tumbuhan</h3>
                <div class="grid grid-cols-2 gap-4">
                  <ul class="list-disc browser-default pl-4 m-0">
                    <li>Jumlah individu</li>
                    <li>Habitus</li>
                    <li>Keliling/diameter</li>
                  </ul>
                  <ul class="list-disc browser-default pl-4 lg:pl-8 m-0">
                    <li>Tinggi pohon</li>
                    <li>Posisi pohon</li>
                    <li>Tajuk pohon</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card flex flex-col lg:flex-row items-center rounded-lg m-0 px-6 py-4 gap-4">
              <div class="w-1/2 lg:w-1/4 shrink-0 mx-auto lg:mx-0">
                <PictureImg
                  src="/images/products/inventum/feature-coordinate"
                  alt="Feature 1"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '100%', height: '100px', objectFit: 'contain' }"
                />
              </div>
              <div>
                <h3 class="text-xl font-bold mt-0 mb-2">Pencatatan Data Koordinat</h3>
                <ul class="list-disc browser-default pl-4 m-0">
                  <li>Titik koordinat plot/jalur</li>
                  <li>Titik koordinat setiap individu tumbuhan</li>
                </ul>
              </div>
            </div>
            <div class="card flex flex-col lg:flex-row items-center rounded-lg m-0 px-6 py-4 gap-4">
              <div class="w-1/2 lg:w-1/4 shrink-0 mx-auto lg:mx-0">
                <PictureImg
                  src="/images/products/inventum/feature-tallysheet"
                  alt="Feature 1"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '100%', height: '100px', objectFit: 'contain' }"
                />
              </div>
              <div>
                <h3 class="text-xl font-bold mt-0 mb-2">Tallysheet Digital</h3>
                <p class="m-0">Setelah data selesai diinput, bisa langsung:</p>
                <ul class="list-disc browser-default pl-4 m-0">
                  <li>Download file spreadsheetnya (sudah rapi dalam bentuk tallysheet)</li>
                  <li>Siap digunakan untuk analisis data (tanpa perlu rekap manual)</li>
                </ul>
              </div>
            </div>
            <div class="card flex flex-col lg:flex-row items-center rounded-lg m-0 px-6 py-4 gap-4">
              <div class="w-1/2 lg:w-1/4 shrink-0 mx-auto lg:mx-0">
                <PictureImg
                  src="/images/products/inventum/feature-calculation"
                  alt="Feature 1"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '100%', height: '100px', objectFit: 'contain' }"
                />
              </div>
              <div>
                <h3 class="text-xl font-bold mt-0 mb-2">Perhitungan dan Klasifikasi Otomatis</h3>
                <p class="m-0">File spreadsheet Inventum dilengkapi:</p>
                <ul class="list-disc browser-default pl-4 m-0">
                  <li>Kolom perhitungan otomatis (keliling/diameter, LBDS, dan tajuk)</li>
                  <li>Kolom pengklasifikasian otomatis (habitus/growth-level dan sub-plot)</li>
                </ul>
              </div>
            </div>
            <div class="card flex flex-col lg:flex-row items-center rounded-lg m-0 px-6 py-4 gap-4">
              <div class="w-1/2 lg:w-1/4 shrink-0 mx-auto lg:mx-0">
                <PictureImg
                  src="/images/products/inventum/feature-offline"
                  alt="Feature 1"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '100%', height: '100px', objectFit: 'contain' }"
                />
              </div>
              <div>
                <h3 class="text-xl font-bold mt-0 mb-2">Dapat Digunakan Tanpa Sinyal</h3>
                <p class="m-0">Dalam kondisi tanpa internet, tetap bisa:</p>
                <ul class="list-disc browser-default pl-4 m-0">
                  <li>Input data di Inventum</li>
                  <li>Download file spreedsheet datanya</li>
                </ul>
                <p class="m-0">Sangat berguna untuk kerja lapangan!</p>
              </div>
            </div>
            <div class="card flex flex-col lg:flex-row items-center rounded-lg m-0 px-6 py-4 gap-4">
              <div class="w-1/2 lg:w-1/4 shrink-0 mx-auto lg:mx-0">
                <PictureImg
                  src="/images/products/inventum/feature-backup"
                  alt="Feature 1"
                  :extensions="['webp', 'png']"
                  :img-style="{ width: '100%', height: '100px', objectFit: 'contain' }"
                />
              </div>
              <div>
                <h3 class="text-xl font-bold mt-0 mb-2">Auto Backup Data</h3>
                <p class="m-0">Bisa secara otomatis membackup data ke server ketika ada sinyal, sehingga:</p>
                <ul class="list-disc browser-default pl-4 m-0">
                  <li>Data pengguna tetap aman</li>
                  <li>Ada pilihan Restore jika dibutuhkan</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="playlist"
        class="relative container-lg mx-0 w-full lg:mx-auto mt-24 mb-12 lg:my-48 green white-text px-9 lg:px-18 pt-6 pb-18 rounded-3xl lg:pt-24 lg:pb-36"
        :style="{
          backgroundImage: `url('/images/services/web-app/geometric-0.webp') !important`,
          backgroundSize: 'cover !important',
          backgroundPosition: 'left center !important',
          backgroundRepeat: 'no-repeat !important',
        }"
      >
        <h2 class="center-align text-3xl lg:text-4xl font-bold white-text mb-12">Kenali Inventum Lebih Jauh!</h2>
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-10 center-align">
          <iframe
            src="https://www.youtube.com/embed/f6593h1HPck"
            title=""
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
            class="aspect-9/16 hide-on-med-and-down"
          ></iframe>
          <iframe
            src="https://www.youtube.com/embed/srQc8sR1VmI"
            title=""
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
            class="aspect-9/16"
          ></iframe>
          <iframe
            src="https://www.youtube.com/embed/HNH6M9smbG8"
            title=""
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
            class="aspect-9/16 hide-on-med-and-down"
          ></iframe>
        </div>
        <p class="center-align text-xl lg:text-2xl text-balance font-medium mt-12">
          Lihat video-video lainnya tentang Inventum:
        </p>
        <div class="flex-container items-center justify-center gap-4">
          <a
            href="https://www.youtube.com/playlist?list=PLy60CguY4gM5fEmXQOc9fiAH_4aaNN1SX"
            target="_blank"
            rel="noreferrer"
            class="btn teal waves-effect txt--bold"
          >
            Playlist “Mengenal Inventum!”
          </a>
          <a
            href="https://www.youtube.com/playlist?list=PLy60CguY4gM4K5jSY6rBox7FXd0HWoDhX"
            target="_blank"
            rel="noreferrer"
            class="btn teal waves-effect txt--bold"
          >
            Playlist “Aplikasi Inventum!”
          </a>
        </div>
      </section>

      <section id="howto" class="relative container-lg my-24 lg:my-48">
        <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 mb-12">
          5 Langkah Singkat Menggunakan Inventum!
        </h2>
        <div class="flex flex-col lg:flex-row gap-y-6 lg:gap-x-4 lg:gap-y-12 center-align mb-6 justify-center">
          <div>
            <PictureImg
              src="/images/products/inventum/inventum-1"
              alt="Planning"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '58vh', maxHeight: '800px', margin: 'auto' }"
            />
            <h4 class="text-xl lg:text-xl m-0 lg:mb-2 txt--bold green white-text mt-4 inline-block px-4 lg:px-3 py-2">
              1. Project Settings
            </h4>
          </div>
          <div class="mb-2 lg:mb-0" style="min-width: 72px">
            <PictureImg
              src="/images/services/web-app/arrow-right"
              alt="Design"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2 object-contain hide-on-med-and-down"
              :img-style="{ display: 'block', maxWidth: '98px', width: '100%', height: '100%', margin: 'auto' }"
            />
            <svg
              class="object-contain hide-on-large-only mx-auto"
              width="48"
              height="60"
              viewBox="0 0 48 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="display: block"
            >
              <rect x="22" y="16" width="4" height="30" rx="2" fill="black" />
              <path
                d="M12 32 L24 48 L36 32"
                stroke="black"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div>
            <PictureImg
              src="/images/products/inventum/inventum-2"
              alt="Design"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '58vh', maxHeight: '800px', margin: 'auto' }"
            />
            <h4 class="text-xl lg:text-xl m-0 lg:mb-2 txt--bold green white-text mt-4 inline-block px-4 lg:px-3 py-2">
              2. Field Settings
            </h4>
          </div>
          <div class="mb-2 lg:mb-0" style="min-width: 72px">
            <PictureImg
              src="/images/services/web-app/arrow-right"
              alt="Design"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2 object-contain hide-on-med-and-down"
              :img-style="{ display: 'block', maxWidth: '98px', width: '100%', height: '100%', margin: 'auto' }"
            />
            <svg
              class="object-contain hide-on-large-only mx-auto"
              width="48"
              height="60"
              viewBox="0 0 48 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="display: block"
            >
              <rect x="22" y="16" width="4" height="30" rx="2" fill="black" />
              <path
                d="M12 32 L24 48 L36 32"
                stroke="black"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div>
            <PictureImg
              src="/images/products/inventum/inventum-3"
              alt="Friendly Illustration"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '58vh', maxHeight: '800px', margin: 'auto' }"
            />
            <h4 class="text-xl lg:text-xl m-0 lg:mb-2 txt--bold green white-text mt-4 inline-block px-4 lg:px-3 py-2">
              3. Create Records
            </h4>
          </div>
        </div>
        <div class="flex flex-col lg:flex-row gap-y-6 lg:gap-x-4 lg:gap-y-12 center-align mb-12 justify-center">
          <div class="mb-2 lg:mb-0 hide-on-large-only" style="min-width: 72px">
            <svg
              class="object-contain hide-on-large-only mx-auto"
              width="48"
              height="60"
              viewBox="0 0 48 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="display: block"
            >
              <rect x="22" y="16" width="4" height="30" rx="2" fill="black" />
              <path
                d="M12 32 L24 48 L36 32"
                stroke="black"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div>
            <PictureImg
              src="/images/products/inventum/inventum-4"
              alt="Review"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '58vh', maxHeight: '800px', margin: 'auto' }"
            />
            <h4 class="text-xl lg:text-xl m-0 lg:mb-2 txt--bold green white-text mt-4 inline-block px-4 lg:px-3 py-2">
              4. View Records
            </h4>
          </div>
          <div class="mb-2 lg:mb-0" style="min-width: 72px">
            <PictureImg
              src="/images/services/web-app/arrow-right"
              alt="Design"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2 object-contain hide-on-med-and-down"
              :img-style="{ display: 'block', maxWidth: '98px', width: '100%', height: '100%', margin: 'auto' }"
            />
            <svg
              class="object-contain hide-on-large-only mx-auto"
              width="48"
              height="60"
              viewBox="0 0 48 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="display: block"
            >
              <rect x="22" y="16" width="4" height="30" rx="2" fill="black" />
              <path
                d="M12 32 L24 48 L36 32"
                stroke="black"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div>
            <PictureImg
              src="/images/products/inventum/inventum-5"
              alt="Handover"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '58vh', maxHeight: '800px', margin: 'auto' }"
            />
            <h4 class="text-xl lg:text-xl m-0 lg:mb-2 txt--bold green white-text mt-4 inline-block px-4 lg:px-3 py-2">
              5. Backup Records
            </h4>
          </div>
        </div>
      </section>

      <section id="result" class="mv-8 green white-text py-20">
        <div class="container flex-container items-center justify-center gap-4">
          <div>
            <p class="text-3xl lg:text-5xl font-bold text-center lg:text-left mt-0 mb-2 lg:mb-6">
              Setelah input data di Inventum, bisa langsung download file spreadsheetnya!
            </p>
            <a
              href="/inventum/example/Vegetasi_Example.zip"
              target="_blank"
              rel="noreferrer"
              class="btn waves-effect btn-large font-medium hide-on-med-and-down"
              download
              >Download Contoh Excel dari Inventum!</a
            >
          </div>
          <div class="flex-item">
            <PictureImg
              src="/images/products/inventum/illus-thumbsup"
              alt=""
              :extensions="['webp', 'png']"
              :img-style="{ display: 'block', height: '24vh', maxHeight: '300px', margin: 'auto' }"
              class="hide-on-large-only"
            />
            <PictureImg
              src="/images/products/inventum/illus-thumbsup"
              alt=""
              :extensions="['webp', 'png']"
              :img-style="{ display: 'block', height: '30vh', maxHeight: '300px', margin: 'auto' }"
              class="hide-on-med-and-down"
            />
            <a
              href="/inventum/example/Vegetasi_Example.zip"
              target="_blank"
              rel="noreferrer"
              class="btn waves-effect txt--bold hide-on-large-only mt-4"
              download
              >Download Contoh Excel Inventum!</a
            >
          </div>
        </div>
      </section>

      <section
        id="cta"
        class="relative container-lg h-auto mx-0 w-full lg:mx-auto mt-24 lg:mt-48 lg:mb-48 flex flex-col items-center justify-start lg:justify-center"
      >
        <div
          class="green px-9 lg:px-18 pt-24 pb-18 lg:py-24 mb-24 lg:mb-0 rounded-3xl"
          :style="{
            backgroundImage: `url('/images/services/web-app/geometric-0.webp') !important`,
            backgroundSize: 'cover !important',
            backgroundPosition: 'left center !important',
            backgroundRepeat: 'no-repeat !important',
          }"
        >
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 px-2 lg:px-6 items-center">
            <div class="text-center lg:text-left">
              <h2 class="text-2xl lg:text-4xl font-bold white-text m-0">
                Mau tahu penjelasan lebih detail tentang tahapan menggunakan Inventum?
              </h2>
              <PictureImg
                src="/images/products/inventum/guide-desktop"
                alt=""
                :extensions="['webp', 'png']"
                :img-style="{ objectFit: 'contain', width: '100%' }"
                img-class="hide-on-med-and-down mv-5"
              />
              <div class="hide-on-large-only mv-4">
                <PictureImg
                  src="/images/products/inventum/guidebook-mobile"
                  alt=""
                  :extensions="['webp', 'png']"
                  :img-style="{ display: 'inline-block', height: '55vh', maxHeight: '600px' }"
                />
                <p class="white-text text-2xl lg:text-2xl mv-5 font-medium text-balance">
                  Semuanya dijelaskan secara lengkap di sini!
                </p>
              </div>
              <a
                href="/panduaninventum"
                target="_blank"
                rel="noopener noreferrer"
                class="btn teal waves-effect btn-large font-medium"
                tabindex="0"
              >
                Download Buku Panduan Pengguna Inventum!
              </a>
            </div>
            <div class="hide-on-med-and-down text-center">
              <PictureImg
                src="/images/products/inventum/guidebook-desktop"
                alt=""
                :extensions="['webp', 'png']"
                :img-style="{ display: 'inline-block', height: '70vh', maxHeight: '600px' }"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="pricing" class="mv-8">
        <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 lg:mt-48 lg:mb-12">
          Paket Inventum
        </h2>
        <div class="container flex flex-col lg:flex-row">
          <BenefitTable class="mb-6" />
          <div class="lg\:ml-16 flex flex-col gap-4 w-full lg:w-1/2">
            <div class="card p-4">
              <h6 class="card-title">Basic</h6>
              <ul>
                <li v-for="item in basicPackage" :key="item.id" class="mv-2">
                  <div class="flex-container flex-row">
                    <div class="flex-item" style="flex-basis: 50%">
                      <strong>{{ item.product_type.toUpperCase() }}</strong>
                      <br />
                      <span>{{ item.active_time | asDuration }}</span>
                    </div>
                    <div class="flex-item" style="flex-basis: 50%; justify-self: flex-end">
                      <div style="text-align: right">{{ item.price | monefy }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="card p-4">
              <h6 class="card-title">Pro</h6>
              <ul>
                <li v-for="item in proPackage" :key="item.id" class="mv-2">
                  <div class="flex-container flex-row">
                    <div class="flex-item" style="flex-basis: 50%">
                      <strong>{{ item.product_type.toUpperCase() }}</strong>
                      <br />
                      <span>{{ item.active_time | asDuration }}</span>
                    </div>
                    <div class="flex-item" style="flex-basis: 50%; justify-self: flex-end">
                      <div style="text-align: right">{{ item.price | monefy }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="requirements" class="mv-8">
        <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 lg:mt-12 lg:mb-12">
          Requirements
        </h2>
        <div class="container flex-container pv-4">
          <div class="flex-item card mh-2 p-4" style="flex-basis: 50%">
            <h6 class="card-title">Minimum</h6>
            <ul>
              <li>Browser Versi Terbaru</li>
              <li>Free Storage Space 20MB</li>
              <li>System Memory (RAM) 1GB</li>
              <li>Internet Connection (hanya saat aktivasi dan pilihan backup ke Google Drive)</li>
              <li>For iPhone: minimum iOS & Safari 16</li>
            </ul>
          </div>
          <div class="flex-item card mh-2 p-4" style="flex-basis: 50%">
            <h6 class="card-title">Recommended</h6>
            <ul>
              <li>Google Chrome Versi Terbaru</li>
              <li>Free Storage Space 50MB+</li>
              <li>System Memory (RAM) 2GB+</li>
            </ul>
          </div>
        </div>
      </section>

      <section id="numbers" class="mv-8">
        <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 lg:mt-12 lg:mb-12">
          Capaian Aplikasi Inventum
        </h2>
        <PictureImg
          src="/images/products/inventum/indonesia-desktop"
          alt="Numbers"
          :extensions="['webp', 'png']"
          img-class="hide-on-med-and-down"
          :img-style="{
            display: 'block',
            height: '60vh',
            maxHeight: '800px',
            maxWidth: '95%',
            objectFit: 'contain',
            margin: 'auto',
          }"
        />
        <PictureImg
          src="/images/products/inventum/indonesia-mobile"
          alt="Numbers"
          :extensions="['webp', 'png']"
          img-class="hide-on-large-only"
          :img-style="{
            display: 'block',
            height: '30vh',
            maxHeight: '500px',
            maxWidth: '95%',
            objectFit: 'contain',
            margin: 'auto',
          }"
        />
        <div class="container green white-text rounded-3xl mt-0 lg:mt-12 px-4 lg:px-18">
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-12 text-center py-4 px-9 items-center">
            <div>
              <p class="text-4xl lg:text-5xl font-bold m-0 teal-text text-darken-2">1700+</p>
              <p class="text-xl lg:text-2xl font-bold m-0">Pengguna Aplikasi Inventum</p>
            </div>
            <div>
              <p class="text-4xl lg:text-5xl font-bold m-0 teal-text text-darken-2">10+</p>
              <p class="text-xl lg:text-2xl font-bold m-0">Pelatihan Inventum Terlaksana</p>
            </div>
            <div>
              <p class="text-4xl lg:text-5xl font-bold m-0 teal-text text-darken-2">1100+</p>
              <p class="text-xl lg:text-2xl font-bold m-0">Mahasiswa Terjangkau Pelatihan Inventum</p>
            </div>
          </div>
        </div>
        <p class="text-center text-base lg:text-xl font-medium m-0 mt-6 mb-2 lg:mt-12 px-12">
          Aplikasi Inventum telah diintegrasikan dalam kegiatan praktikum di:
        </p>
        <PictureImg
          src="/images/products/inventum/universities-desktop"
          alt="Universitas"
          :extensions="['webp', 'png']"
          img-class="hide-on-med-and-down"
          :img-style="{ display: 'block', maxWidth: '65%', margin: 'auto' }"
        />
        <PictureImg
          src="/images/products/inventum/universities-mobile"
          alt="Universitas"
          :extensions="['webp', 'png']"
          img-class="hide-on-large-only mt-2"
          :img-style="{ display: 'block', maxWidth: '90%', margin: 'auto' }"
        />
      </section>

      <section
        id="testimony"
        class="relative mt-24 mb-24 lg:my-48 green py-20 white-text"
        :style="{ backgroundImage: `url('/images/services/web-app/geometric-1.webp') !important` }"
      >
        <div class="testimony-slider">
          <h2 class="center-align text-3xl lg:text-4xl font-bold white-text mb-12">
            Apa Kata Mereka tentang Inventum?
          </h2>
          <button
            class="testimony-slider__arrow testimony-slider__arrow--left hide-on-med-and-down"
            aria-label="Previous testimony"
            tabindex="0"
            @click="handleTestimonyPrev"
            @keydown.enter="handleTestimonyPrev"
          >
            <span>&lt;</span>
          </button>
          <button
            class="testimony-slider__arrow testimony-slider__arrow--right hide-on-med-and-down"
            aria-label="Next testimony"
            tabindex="0"
            @click="handleTestimonyNext"
            @keydown.enter="handleTestimonyNext"
          >
            <span>&gt;</span>
          </button>
          <div class="testimony-slider__indicators hide-on-large-only">
            <div
              v-for="id in testimonies.length"
              :key="id"
              class="testimony-slider__indicators__dot"
              :class="{ active: activeTestimony === id }"
            ></div>
          </div>
          <div ref="testimonySlider" class="testimony-slider__container">
            <div v-for="(testimony, idx) in testimonies" :key="idx" class="testimony-slider__item">
              <div class="testimony-card">
                <span class="testimony-card__quote testimony-card__quote--open">“</span>
                <div class="testimony-card__text">
                  <span v-html="testimony.content"></span>
                </div>
                <span class="testimony-card__quote testimony-card__quote--close">”</span>
                <div class="testimony-card__profile">
                  <PictureImg
                    class="testimony-card__photo"
                    :src="testimony.image"
                    alt="Testimony Photo"
                    :extensions="['webp', 'png']"
                    img-class="testimony-card__image"
                  />
                  <div class="testimony-card__name">
                    <b>{{ testimony.name }}</b>
                    <span v-html="testimony.title"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="advantages" class="mt-24 mb-24">
        <div class="container">
          <h2
            class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 lg:mt-12 lg:mb-12"
          >
            Keuntungan menggunakan Inventum
          </h2>
        </div>
        <div
          class="grid grid-cols-1 lg:grid-cols-3 center-align mv-6"
          style="flex-wrap: wrap; width: 90%; position: relative; transform: translateX(-50%); left: 50%"
        >
          <div v-for="(advantage, idx) in advantages" :key="idx" class="flex-item m-2" style="flex-basis: 30%">
            <PictureImg
              :src="advantage.img"
              :alt="advantage.title"
              :extensions="['svg', 'webp', 'png']"
              :img-style="{ display: 'block', height: '18vh', maxHeight: '150px', margin: 'auto' }"
            />
            <p class="text-2xl lg:text-2xl font-bold my-0">{{ advantage.title }}</p>
            <p class="text-lg lg:text-lg mt-1 mb-0">{{ advantage.desc }}</p>
          </div>
        </div>
      </section>

      <section id="download-cta" class="mv-8 green white-text py-11">
        <div class="container flex items-center justify-center gap-6 pv-4 text-center lg:text-left">
          <PictureImg
            src="/images/products/inventum/illus-cta-download"
            alt="Get it on Google Play"
            version="1"
            :extensions="['webp', 'png']"
            :img-style="{ width: '80%' }"
            class="hide-on-med-and-down"
          />
          <div class="w-full lg:w-1/2">
            <p class="font-bold text-3xl lg:text-3xl white green-text rounded-lg py-2 px-4 inline-block mb-2">
              Jadi, tunggu apalagi?
            </p>
            <PictureImg
              src="/images/products/inventum/illus-cta-download-mobile"
              alt="Get it on Google Play"
              version="1"
              :extensions="['webp', 'png']"
              :img-style="{ width: '60%' }"
              class="hide-on-large-only"
            />
            <p class="text-3xl lg:text-6xl font-bold mt-0 mb-4">Yuk download aplikasi Inventum sekarang!</p>
            <div class="flex flex-col lg:flex-row items-center gap-6 text-center">
              <div>
                <a
                  class="cta-googleplay"
                  href="https://play.google.com/store/apps/details?id=id.rasylva.inventum&utm_source=rasylva-web&utm_campaign=products-inventum-cta"
                >
                  <PictureImg
                    src="/images/products/inventum/googleplay-download"
                    alt="Get it on Google Play"
                    version="1"
                    :extensions="['webp', 'png']"
                    :img-style="{ width: '160px' }"
                  />
                </a>
                <p class="m-0 text-sm">Android</p>
              </div>
              <div>
                <a class="cta-pwa" href="/inventum?utm_source=rasylva-web&utm_campaign=products-inventum-cta">
                  <PictureImg
                    src="/images/products/inventum/pwa-launch"
                    alt="Launch as PWA"
                    version="1"
                    :extensions="['webp', 'png']"
                    :img-style="{ width: '156px', marginLeft: '1px' }"
                  />
                </a>
                <p class="m-0 text-sm">
                  iOS, Windows, Linux, dll&nbsp;
                  <span
                    data-tooltip="PWA adalah singkatan dari Progressive Web App. PWA merupakan sebuah website yang bisa digunakan seperti aplikasi biasa, sehingga dapat digunakan secara offline. PWA hanya membutuhkan internet saat pertama kali dibuka."
                    ><i class="material-icons" style="font-size: 16px">help_outline</i></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="seo-text" class="container pt-8">
        <p style="font-size: 16px">Inventum (Alat Inventarisasi Tumbuhan)</p>
        <p>
          Inventum adalah aplikasi inventarisasi tumbuhan yang dapat digunakan untuk menginput data tumbuhan secara
          offline. Aplikasi ini dirancang khusus untuk mempermudah proses pengumpulan data tumbuhan, karena data yang
          diinput di lapangan dapat langsung didownload secara offline dalam bentuk tallysheet (xlsx/csv).
        </p>
        <p>
          Beberapa kegiatan yang dapat menggunakan aplikasi Inventum antara lain: analisis vegetasi, inventarisasi
          hutan, menghitung carbon stock/stok karbon, mengkaji habitat satwa liar, mensensus atau survey tanaman di
          suatu RTH (Ruang Terbuka Hijau), membuat diagram profil hutan, melakukan Pengawasan dan Penilaian Tanaman RHL
          (Rehabilitasi Hutan dan Lahan), dan masih banyak kegiatan lainnya yang bisa menggunakan Inventum.
        </p>
        <p>
          Aplikasi Inventum dapat menghemat waktu pengguna, karena tidak perlu lagi melakukan pekerjaan yang berulang.
          Aplikasi Inventum juga sangat efisien, karena pengguna tidak perlu menghabiskan waktu dan tenaga untuk merekap
          data dari kertas ke komputer. Pengoperasian Inventum juga sudah didesain agar bisa dilakukan dengan cepat dan
          mudah selama di lapangan.
        </p>
        <p>
          Aplikasi Inventum dapat mempermudah proses awal pengolahan data analisis vegetasi. Dengan sistem perhitungan
          otomatisnya, Inventum dapat secara otomatis menghitung keliling, diameter, luas bidang dasar (LBDs), maupun
          tajuk suatu tumbuhan. Perhitungan tajuk yang tersedia yaitu perhitungan Luas Kanopi, cr_curve, cr_depth, dan
          cr_radius yang datanya langsung bisa dimasukkan ke aplikasi SExI-FS. Selain itu, Inventum juga secara otomatis
          mengklasifikasikan habitus/growth-form/growth-level suatu tumbuhan berdasarkan data pengaturan yang diisi oleh
          pengguna, seperti tumbuhan bawah, semai, pancang, tiang, pohon, paku, palem, pandan, herba, dan lain-lain.
        </p>
        <p>
          Aplikasi Inventum didesain khusus untuk pengguna yang sudah biasa mengumpulkan data tumbuhan. Tersedia
          beberapa pilihan variabel pengukuran dan perhitungan yang dapat dipilih untuk pengisian data, seperti jumlah
          individu, keliling, diameter, dan tinggi pohon (tinggi bebas cabang, tinggi tajuk terlebar, tinggi total).
          Selain itu, Inventum juga memfasilitasi pengguna yang akan membuat diagram profil hutan, dengan menyediakan
          pilihan pengisian data seperti tajuk terpanjang, tajuk terpendek, arah mata angin, posisi (x, y) pohon, dan
          lain-lain. Pengguna juga dapat menginput data titik koordinat plot/jalur dan titik koordinat individu tumbuhan
          di aplikasi Inventum.
        </p>
        <p>
          Aplikasi Inventum sudah digunakan dan diuji oleh praktisi maupun mahasiswa di bidang ekologi dan kehutanan di
          Indonesia. Data yang telah di-input akan aman karena tersimpan di perangkat pengguna dan juga dapat di-backup
          ke cloud (Google Drive). Selain itu, dengan menggunakan Inventum artinya ikut serta dalam mengurangi pemakaian
          kertas (paperless) dan membantu mengurangi limbah kertas (paper waste). Tidak akan ada lagi kertas yang
          terbuang dalam jumlah banyak akibat pencatatan data manual di lapangan.
        </p>
        <p>
          Masih ragu menggunakan aplikasi Inventum? Download dan coba gunakan saja dulu! Dijamin tak akan pindah ke
          kertas lagi 😊
        </p>
      </section>
    </main>
    <PageFooter />
  </div>
</template>

<script>
import BenefitTable from '~/components/inventum/benefit-table';
import PageFooter from '~/components/page-footer';
import PageHeader from '~/components/page-header';
import PictureImg from '~/components/picture-img';

import datetimeMixin from '~/mixins/datetime';
import moneyMixin from '~/mixins/money';

export default {
  components: {
    BenefitTable,
    PageFooter,
    PageHeader,
    PictureImg,
  },
  mixins: [datetimeMixin, moneyMixin],
  data: () => ({
    isLoggedIn: false,
    advantages: [
      {
        img: '/images/products/inventum/illus-time-saving',
        title: 'Time Saving',
        desc: 'Hemat waktumu tanpa melakukan pekerjaan yang berulang. Kumpulkan saja datamu, dan biarkan Inventum melakukan proses lainnya.',
      },
      {
        img: '/images/products/inventum/illus-efficient',
        title: 'Efficient',
        desc: 'Tidak perlu lagi memindahkan datamu dari kertas ke komputer. Cukup input dan unduh saja datamu secara langsung di lapangan.',
      },
      {
        img: '/images/products/inventum/illus-auto-calc',
        title: 'Automatic Calculation',
        desc: 'Tidak perlu lagi menghitung rumus secara manual. Inventum akan melakukannya secara otomatis untukmu.',
      },
      {
        img: '/images/products/inventum/illus-easy',
        title: 'Easy to Use',
        desc: 'Pengisian data di Inventum sudah didesain khusus untukmu yang biasa melakukan analisis vegetasi. Inventum telah diuji oleh para praktisi di bidang ekologi dan kehutanan untuk memfasilitasi kebutuhanmu.',
      },
      {
        img: '/images/products/inventum/illus-secure',
        title: 'Secure',
        desc: 'Datamu akan aman, karena semua datamu disimpan di perangkatmu sendiri dan bisa dibackup ke cloud.',
      },
      {
        img: '/images/products/inventum/illus-eco-friendly',
        title: 'Eco Friendly',
        desc: 'Menggunakan Inventum sama dengan ikut membantu dalam mengurangi pemakaian kertas. Tidak akan ada lagi kertas yang terbuang dalam jumlah banyak.',
      },
    ],
    screenshots: [
      { src: '/images/products/inventum/1-project-settings', alt: 'Inventum Project Settings' },
      { src: '/images/products/inventum/2-field-config', alt: 'Inventum Field Config' },
      { src: '/images/products/inventum/3-input-config', alt: 'Inventum Input Config' },
      { src: '/images/products/inventum/4-create-record', alt: 'Inventum Create Record' },
      { src: '/images/products/inventum/5-view-records', alt: 'Inventum View Records' },
      { src: '/images/products/inventum/6-manage-records', alt: 'Inventum Manage Records' },
      { src: '/images/products/inventum/7-backup-records', alt: 'Inventum Backup Records' },
    ],
    availablePackages: [],
    testimonies: [
      {
        image: '/images/products/inventum/testimony/Foto-Zakaria',
        name: 'Zakaria Al Anshori, S.Hut',
        title: 'Botanist Yayasan Botani Tropika Indonesia,<br/>Alumni Fakultas Kehutanan IPB',
        content: `Sebagai praktisi di bidang inventarisasi sumberdaya hutan,
kegiatan survey terutama dalam pencatatan data biasanya dilakukan
secara konvensional dan akan direkap ulang setelah kegiatan selesai. Hal ini membutuhkan pekerjaan ekstra dan terkadang
memakan waktu input data dan analisis yang lama apabila data survey berjumlah banyak. Kendala teknis pengambilan data
secara konvensional juga sering terjadi, seperti buku lapang yang
basah, lembaran robek, tidak terbaca, dan hilang saat kegiatan.
<br/><br/>
Aplikasi Inventum menawarkan kemudahan pencatatan data di
lapang berbasis aplikasi dengan fitur yang
handy, mudah digunakan, dan mampu memunculkan output rekap data serta analisis data awal dengan format excel, sehingga mengurangi waktu input data secara manual dan pekerjaan menjadi lebih cepat dan efisien.`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Kania',
        name: 'Kania Gita Lestari, S.Hut., M.Si.',
        title: 'Botanist Yayasan Hutan Organik,<br/>Alumni Fakultas Kehutanan IPB',
        content: `Dulu aku harus nyiapin dan bawa peralatan mencatat seperti
alat tulis, buku, papan jalan, dan peralatan lain yang ribet ke
lapang. Tapi sekarang cukup dengan androidku dan aplikasi Inventum saja semua halnya jadi lebih mudah.
<br/><br/>
Inventum itu bagiku seperti ibu peri yang membantu segala pekerjaanku menjadi lebih cepat, seperti penginputan data lapang yang otomatis rapi di aplikasi, memudahkan perekapan data,
bisa dipakai offline, dan juga hasilnya bisa didownload langsung
bentuk Excel sehingga aku lebih cepat membuat analisis dan
pelaporan data. Kalo ga ada aplikasi Inventum, aku ga tau lagi deh
seribet apa kalo nganalisis vegetasi yang beribu-ribu individu itu,
kepalaku pusing 7 keliling kayanya. So, thank you so much Rasylva.id
yang sudah membuat aplikasi yang sangat bermanfaat ini!`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Adin',
        name: 'Adin Ayu Andriyani, S.Si., M.Sc.',
        title: 'Alumni Magister Biologi,<br/>Fakultas Biologi Universitas Gadjah Mada',
        content: `Dahulu ketika pertama kali saya praktik lapang, kertas dan alat tulis adalah hal yang penting untuk mencatat hasil analisis vegetasi.
Ketika memulai penelitian tahun lalu, saya masih menggunakan
sistem manual tersebut. Resiko seperti kertas basah terkena hujan
atau kertas tercecer beberapa kali saya rasakan. Setelah itu, saya diberitahu mengenai Inventum dan mencobanya.
<br/><br/>
Menurut saya, Inventum sangat efektif untuk membantu terutama penelitian dengan banyak data. Aplikasi ini memiliki tampilan
yang mudah dipahami saat memasukkan data. Proses penyimpanan memiliki beberapa opsi dan terdapat fitur Pro yang langsung membantu menganalisa data kita. Paketnya juga terjangkau dan sesuai dengan kemudahan yang didapatkan. Terima kasih Inventum, saya merasa sangat terbantu ketika mengumpulkan data penelitian.
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Radit',
        name: 'Raditia Nugraha, S.Si.',
        title: 'Mahasiswa Magister Biologi,<br/>Fakultas Biologi Universitas Gadjah Mada',
        content: `Dalam melakukan inventarisasi keanekaragaman tumbuhan atau pembuatan profil hutan tidak lepas
dari proses pencatatan data di buku lapangan yang
tentunya memakan waktu lebih apalagi jika
terkendala hujan, ditambah lagi memindahkan data
satu per satu setelahnya untuk dapat dianalisis.
<br/><br/>
Penggunaan aplikasi inventum tentunya membuat pengerjaan lebih efisien. Adanya pengkategorian habitus
di awal meminimalisir kesalahan dalam pencatatan data. Tentunya dengan bermodal handphone, bisa dipakai secara offline, rapi, dan bisa didownload dalam bentuk excel.
Thank you so much sudah membantu penelitian saya.
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Robeth',
        name: 'Robeth Ahmad Fathony, S.Hut.',
        title: 'Alumni Fakultas Kehutanan dan Lingkungan,<br/>IPB University',
        content: `Inventum tuh super helpful banget buat
rekap data lapangan. Biasanya kan ribet
banget bawa kertas sama bolpen, tapi
sekarang tinggal input via HP dan semuanya
auto sync. The best part is, it's super
eco-friendly karena no more paper waste.
<br/><br/>
Jadi kalau lo anak kehutanan atau sering
kerja di lapangan, this app is literally a
game changer. Highly recommended, sih!"
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Safira',
        name: 'Safira Arda Meylia, S.Hut., M.Si.',
        title: 'Alumni Fakultas Kehutanan dan Lingkungan,<br/>IPB University',
        content: `Inventum Rasylva ini benar-benar bantu
banget sih untuk proses input data analisis
vegetasi, baik sensus maupun sampling.
Ga ada cerita lagi waktu istirahat malam buat ngetik data di laptop, hihi. Dan paperless
tentunya. Asiknya lagi, tanpa internet pun
tetap bisa buat input + download hasil excelnya.
<br/><br/>
Buat sobat-sobat anveg, ayo gass download
Inventum. Highly recommend pokoknya!
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Rizka',
        name: 'Aditya Rizka Puspita, S.Pd., M.Sc.',
        title: 'Alumni Magister Biologi,<br/>Fakultas Biologi Universitas Gadjah Mada',
        content: `Inventum membuat pencatatan vegetasi
di lapangan lebih ringkas, tanpa perlu banyak
penggunaan kertas, jadi mengurangi peralatan juga.
Selain itu, saat data akan dianalisis juga sudah
tersusun rapi dan terkategorisasi sesuai
standar yang sudah ditetapkan. Canggih banget, sih!
<br/><br/>
Ngga perlu khawatir data tercecer,
udah gitu biaya langganannya juga bisa disesuaikan
dengan lama waktu pengambilan data.
Jadi ngga ada deh subscription percuma.
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Gafra',
        name: 'Gafra Favian Ratmoro',
        title: 'Mahasiswa Fakultas Biologi,<br/>Universitas Gadjah Mada',
        content: `Aplikasi Inventum sangat membantu dalam praktikum Mata
Kuliah Ekologi dan Konservasi. Sebelumnya, acara Analisis
Parameter Vegetasi harus repot print kertas. Banyak banget
risiko kertas kotor, kena tetesan air, pulpen jatuh dan hilang,
dan ga bisa dihapus kalau salah.
<br/><br/>
Sekarang dimudahkan dengan Inventum, cukup dengan ponsel saja. Kalau ada kesalahan bisa langsung dikoreksi, dan bisa dengan mudah dioperasikan satu tangan. Selain itu, juga banyak
fitur otomatisnya yang mempermudah perhitungan, seperti
otomatis bisa hitung DBH dan LBDS hanya dari keliling pohon.
Selain itu, datanya juga langsung masuk ke spreadsheets,
jadi ga perlu repot pindahin data saat kita mau mengolahnya.
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Salwa',
        name: 'Salwa Nikmatul Maula Amin, S.Hut.',
        title: 'Alumni Fakultas Kehutanan dan Lingkungan,<br/>IPB University',
        content: `Sebelum mengenal Inventum, pencatatan anveg dilakukan
manual tulis tangan di buku, belum lagi rekapitulasi hasil anveg
yang perlu kerja ekstra. Sejak mengenal Inventum, pencatatan
anveg terasa sangat efisien, dibantu fitur auto detect kosakata nama jenis tumbuhan sangat mempermudah pencatatan serta
mencegah typo. Fitur auto rekap data canggih dengan output
excel lengkap, sangat memanjakan peneliti dalam perekapan
data hasil anveg. Selain itu, Inventum dapat digunakan tanpa internet, jadi tidak perlu khawatir ketika hilang sinyal di hutan.
<br/><br/>
Menurut saya, Inventum sangat memudahkan dan membantu peneliti dalam pencatatan hasil anveg. Terimakasih Inventum, semoga sukses selalu dan senantiasa berkembang.
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Dona',
        name: 'Dona Rendra M.P. Yullyyanto, S.Hut.',
        title: 'Alumni Fakultas Kehutanan dan Lingkungan,<br/>IPB University',
        content: `Awalnya setiap kali dari lapang selalu kepikiran sama ratusan bahkan ribuan data yang harus diinput buat dianalisis. Belum lagi kalau jadwal ke lapangnya padat, jadi effort banget harus input data
dari buku lapangan ke excel. Kadang input data anveg sampe begadang, eh tulisan sendiri di buku catatan gak kebaca gara-gara
basahlah, sobeklah, tulisan kayak ceker ayam lah hahaha.
<br/><br/>
Eh setelah dikenalin sama Inventum semua keresahanku itu pudar!
Aku sudah berteman dengan Inventum sekitar 3 tahunan dan
menurutku sangat helpful banget. Selesai dari lapangan, data udah
bisa didownload dengan hasil excel/csv, gak perlu lagi kerja dua kali!
Penggunaan Inventum juga mudah banget. Hal yang paling
menyenangkan menggunakan Inventum itu jadi bisa sombong
ke temen-temen fauna, karena selesai dari lapang gak perlu
memikul PR input data dan ketinggalan tempo hahaha!
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Cuis',
        name: 'Iis Yuningsih, S.Hut., M.Si.',
        title: 'Alumni Fakultas Kehutanan dan Lingkungan,<br/>IPB University',
        content: `Sebelum ada Inventum, selama ini merasa keteteran
saat input data. Terkadang datanya tercecer kalau tulis
manual (di kertas), karena sheetnya bisa sampai
berlembar-lembar. Selain itu, input data manual juga
memerlukan waktu yang lama dan ketelitian yang extra.
<br/><br/>
Tetapi sejak ada Inventum, pekerjaan di lapang menjadi lebih mudah. Selain mudah dioperasikan, sekarang tidak lagi menghabiskan waktu untuk input data manual, karena bisa langsung terinput dan terhitung dari lapang.
Walaupun hp kita ngehang/mati, data yang telah kita
input juga akan tetap aman tersimpan di Inventum.
`,
      },
      {
        image: '/images/products/inventum/testimony/Foto-Rihan',
        name: 'Rihan Stafian Nisa, S.Hut., M.Si.',
        title: 'Alumni Fakultas Kehutanan dan Lingkungan,<br/>IPB University',
        content: `Menurut saya, Inventum sangat memudahkan dalam kegiatan analisis vegetasi. Saya dapat membuat formulir data yang sesuai dengan kebutuhan spesifik anveg. Saya juga dapat dengan mudah menambahkan kolom untuk data seperti spesies, tinggi pohon, diameter batang, dsb. Dengan pakai Inventum, saya dapat memasukkan data lapang secara langsung, dan otomatis direkap ke excel. Ini sangat menghemat waktu, mempermudah analisis data, dan meminimalkan kesalahan. Saya juga dapat memantau data secara real-time saat pakai Inventum. Ini membantu saya mengidentifikasi tren dan pola dalam data, dan memungkinkan saya untuk membuat keputusan yang tepat di lapangan.
<br/><br/>
Saya merekomendasikan Inventum kepada siapapun yang terlibat dalam kegiatan analisis vegetasi hutan dan lahan,
karena sangat membantu meningkatkan efisiensi dan akurasi.
`,
      },
    ],
    activeTestimony: 1,
  }),
  computed: {
    basicPackage() {
      return this.availablePackages.filter((p) => p.product_type.includes('Basic'));
    },
    proPackage() {
      return this.availablePackages.filter((p) => p.product_type.includes('Pro'));
    },
  },
  async mounted() {
    await this.$nextTick();
    setTimeout(async () => {
      await this.$rasylvaApi.init(true);
      await this.fetchPackages();
    }, 10);
    this.setupTestimonyScrollListener();
  },
  beforeDestroy() {
    this.removeTestimonyScrollListener();
  },
  methods: {
    async fetchPackages() {
      return this.$rasylvaApi
        .get('/software-products', { body: { software: 'inventum' } })
        .then((response) => {
          if (response?.status !== 'ok') throw response;
          this.availablePackages = [...response.data];
          return response;
        })
        .catch((error) => {
          console.error(error);
          return error;
        });
    },
    setupTestimonyScrollListener() {
      this.$nextTick(() => {
        const { testimonySlider } = this.$refs;
        if (testimonySlider) {
          this.handleTestimonyScroll = this.handleTestimonyScroll.bind(this);
          testimonySlider.addEventListener('scroll', this.handleTestimonyScroll);
        }
      });
    },
    removeTestimonyScrollListener() {
      const { testimonySlider } = this.$refs;
      if (testimonySlider && this.handleTestimonyScroll) {
        testimonySlider.removeEventListener('scroll', this.handleTestimonyScroll);
      }
    },
    handleTestimonyScroll() {
      const { testimonySlider } = this.$refs;
      if (!testimonySlider) return;

      const scrollLeft = testimonySlider.scrollLeft;
      const containerWidth = testimonySlider.clientWidth;
      const isDesktop = window.innerWidth >= 960;
      const gap = 24;

      let activeIndex;
      if (isDesktop) {
        // On desktop, each item is calc(50% - 12px), so itemWidth = (containerWidth / 2) - 12
        // Distance from start of one item to start of next = itemWidth + gap
        const itemWidth = containerWidth / 2 - 12;
        const itemSpacing = itemWidth + gap;
        // Find which item's start position is closest to current scroll position
        activeIndex = Math.round(scrollLeft / itemSpacing) + 1;
      } else {
        // On mobile, each item is 100% width (containerWidth) with gap between items
        const itemSpacing = containerWidth + gap;
        activeIndex = Math.round(scrollLeft / itemSpacing) + 1;
      }

      // Clamp the index to valid range
      activeIndex = Math.max(1, Math.min(activeIndex, this.testimonies.length));
      this.activeTestimony = activeIndex;
    },
    handleTestimonyPrev() {
      const { testimonySlider } = this.$refs;
      if (!testimonySlider) return;

      const isDesktop = window.innerWidth >= 960;
      const gap = 24;
      let scrollDistance;

      if (isDesktop) {
        // On desktop, scroll by 1 item (50% width) + gap
        const itemWidth = testimonySlider.clientWidth / 2 - 12;
        scrollDistance = itemWidth + gap;
      } else {
        // On mobile, scroll by 1 item (100% width) + gap
        scrollDistance = testimonySlider.clientWidth + gap;
      }

      testimonySlider.scrollBy({ left: -scrollDistance, behavior: 'smooth' });
    },
    handleTestimonyNext() {
      const { testimonySlider } = this.$refs;
      if (!testimonySlider) return;

      const isDesktop = window.innerWidth >= 960;
      const gap = 24;
      let scrollDistance;

      if (isDesktop) {
        // On desktop, scroll by 1 item (50% width) + gap
        const itemWidth = testimonySlider.clientWidth / 2 - 12;
        scrollDistance = itemWidth + gap;
      } else {
        // On mobile, scroll by 1 item (100% width) + gap
        scrollDistance = testimonySlider.clientWidth + gap;
      }

      testimonySlider.scrollBy({ left: scrollDistance, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/mixins';

.hero-section {
  position: relative;
  min-height: 90vh;
  @include desktop {
    min-height: auto;
  }
}

.hero-space {
  height: 90vw;
  @include tablet {
    height: 50vw;
  }
  @include desktop {
    height: 3vh;
  }
}

::v-deep .hero-image {
  position: relative;
  width: 110%;
  margin: 0 24px;
  left: 50%;
  transform: translate(-33%);
  @include tablet {
    width: 68%;
  }
  @include desktop {
    width: 100%;
    left: 90%;
    top: 10%;
  }
}

.hero-text {
  text-align: center;
  @include desktop {
    text-align: left;
    width: 70%;
    margin: auto;
  }
}

[data-tooltip] {
  position: relative;
  border-bottom: 1px dashed #000;
  cursor: help;
}

[data-tooltip]::after {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  content: attr(data-tooltip);
  right: 0;
  top: calc(100% + 10px);
  border-radius: 3px;
  box-shadow: 0 0 5px 2px rgba(100, 100, 100, 0.6);
  background-color: white;
  color: black;
  z-index: 10;
  padding: 8px;
  width: 300px;
  transform: translateY(-20px);
  transition: all 150ms cubic-bezier(0.25, 0.8, 0.25, 1);
}

[data-tooltip]:hover::after {
  opacity: 1;
  transform: translateY(0);
  transition-duration: 300ms;
}

.testimony-slider {
  position: relative;
  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
    &:hover {
      transform: translateY(-50%) scale(1.1);
    }
    span {
      font-size: 3rem;
      font-weight: bold;
      color: $rasylva-teal;
      line-height: 1;
      padding-bottom: 4px;
    }
    &--left {
      left: 2%;
      @media only screen and (min-width: 960px) {
        left: 5%;
      }
    }
    &--right {
      right: 2%;
      @media only screen and (min-width: 960px) {
        right: 5%;
      }
    }
  }
  &__container {
    display: flex;
    margin: auto;
    overflow-x: scroll;
    overflow-y: visible;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    width: 90%;
    gap: 24px;
    @media only screen and (min-width: 960px) {
      overflow-x: auto;
      width: 70%;
    }
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }
  &__item {
    width: 100%;
    flex-shrink: 0;
    overflow: visible;
    margin-top: 20px;
    margin-bottom: 160px;
    @media only screen and (max-width: 960px) {
      &:nth-of-type(1n + 1) {
        scroll-snap-align: start;
        scroll-snap-stop: always;
      }
    }
    @media only screen and (min-width: 960px) {
      width: calc(50% - 12px);
      flex-shrink: 0;
      &:nth-of-type(2n + 1) {
        scroll-snap-align: start;
        scroll-snap-stop: always;
      }
    }
  }
  &__indicators {
    background: none;
    border-radius: 20px;
    bottom: -40px;
    display: flex;
    left: 50%;
    padding: 0;
    position: absolute;
    transform: translateX(-50%);
    z-index: 9;
    &__dot {
      background: rgba(255, 255, 255, 0.5);
      border-radius: 50%;
      border: 0;
      height: 10px;
      margin: 6px;
      width: 10px;
      &.active {
        background: white;
      }
    }
  }
}

.testimony-card {
  background: $rasylva-teal;
  border-radius: 24px;
  padding: 32px 24px 44px;
  position: relative;
  min-height: 400px;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: visible;
  &__quote {
    font-family: serif;
    font-size: 8rem;
    font-weight: bold;
    color: white;
    line-height: 1;
    position: absolute;
    &--open {
      top: -32px;
      left: -4px;
    }
    &--close {
      bottom: -72px;
      right: 0px;
    }
  }
  &__text {
    color: white;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    text-align: center;
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 16px 8px 16px 8px;
  }
  &__profile {
    position: absolute;
    bottom: 0;
    transform: translateY(50%);
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: auto;
    padding-top: 96px;
  }
}

::v-deep .testimony-card {
  &__image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 12px;
    @include desktop {
      width: 120px;
      height: 120px;
    }
  }
  &__name {
    color: #1e1e1e;
    b {
      font-size: 1.25rem;
      display: block;
      margin-bottom: 4px;
      @include desktop {
        font-size: 1.25rem;
      }
    }
    span {
      font-size: 1.125rem;
      opacity: 0.9;
      @include desktop {
        font-size: 1.125rem;
      }
    }
  }
}
</style>
